import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { CommonAlertService } from '@App/services/common-alert.service'
import { AppUtilityService } from '@App/utility/app-utlility.service'
import { takeWhile } from 'rxjs'

@Component({
	selector: 'centax-logo-header',
	templateUrl: './logo-header.component.html',
	styleUrls: ['./logo-header.component.scss'],
})
export class LogoHeaderComponent implements OnInit {
	alive: boolean = true
	constructor(
		private appUtilityService: AppUtilityService,
		private router: Router,
		private commonAlertService: CommonAlertService
	) { }

	ngOnInit(): void {
		this.checkLogin()
	}

	checkLogin() {
		this.appUtilityService.checkForLogin.pipe(takeWhile((_) => this.alive)).subscribe((res) => {
			console.log('check for login', res)
			if (res) {
				// this.isLoggedIn = this.appUtilityService.isLoggedIn();
				// this.email = this.appUtilityService.getDataFromLocalStorage(LocalStorageDataModel.EMAIL);
				// this.userName = this.appUtilityService.getDataFromLocalStorage(LocalStorageDataModel.USER_NAME);
				this.appUtilityService.checkForLogin.next(null)
				this.commonAlertService.successToast('User login successfully')
				this.router.navigate(['/latest-news-updates/all'])
			}
		})
	}

	routeToHome() {
		let routerUrl = this.router.url
		if (routerUrl.includes('mobileVerification') || routerUrl.includes('/latest-news-updates/all')) {
			return;

		} else {

			this.router.navigate(['/latest-news-updates/all']);
		}

	}

	ngOnDestroy() {
		this.alive = false
	}
}
